import { render, staticRenderFns } from "./Feed_Back.vue?vue&type=template&id=62dfb760&"
import script from "./Feed_Back.vue?vue&type=script&lang=js&"
export * from "./Feed_Back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports